import { render, staticRenderFns } from "./JsonFormObject.vue?vue&type=template&id=ce7a10ea"
import script from "./JsonFormObject.vue?vue&type=script&lang=ts"
export * from "./JsonFormObject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports